import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import { LoginComponent } from './account/login.component';
import { ProjectListComponent } from './projects/project-list.component';
import { PreaggregationStrategySelectComponent } from "./import/aggregation/preaggregation-strategy.component";
import { CardsComponent } from './cards/cards.component';
import { ComplexityMgntComponent } from './import/complexity-mgnt/complexity-mgnt.component';
import { ProjectOverviewComponent } from './cards/project-overview.component';
import { ImportWizardComponent } from './import/import-wizard.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'projects',
        pathMatch: 'full'
    },
    {
        path: 'login', component: LoginComponent
    },
    {
        path: 'projects', component: ProjectListComponent
    },
    {
        path: 'preaggregation', component: PreaggregationStrategySelectComponent
    },
    {
        path: 'cards', component: CardsComponent
    },
    {
        path: 'complexity-mgnt', component: ComplexityMgntComponent
    },
    {
        path: 'project-overview', component: ProjectOverviewComponent
    },
    {
        path: 'import-wizard', component: ImportWizardComponent
    },
    {
        path: '**', redirectTo: 'projects'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
